import React, { useEffect, useState } from "react";
import "./RDCertificates.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";

export default function RDCertificates() {
  const [form, setForm] = useState({
    receiptNo: "",
    date: "",
    receivedFrom: "",
    acNo: "",
    nomineeName: "",
    typesOfDeposit: "",
    age: "",
    relation: "",
  });
  const [company, setCompany] = useState(null);
  const [nomineeData, setNomineeData] = useState("");
  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };
  const generatePDF = async () => {
    const input1 = document.getElementById('page1');
    const input2 = document.getElementById('page2');
    const pdf = new jsPDF("p", "mm", "a4");
    // page 1

    const canvas1 = await html2canvas(input1, { scale: 2, useCORS: true, backgroundColor: "#ffffffff" });
    const imgData1 = canvas1.toDataURL('image/png');
    const imgWidth1 = 210;
    const pageHeight1 = 297;
    const imgHeight1 = (canvas1.height * imgWidth1) / canvas1.width;
    pdf.addImage(imgData1, 'PNG', 0, 0, imgWidth1, imgHeight1);

    // page 2 
    pdf.addPage();
    const canvas2 = await html2canvas(input2, { scale: 2, useCORS: true, backgroundColor: "#ffffffff" });
    const imgData2 = canvas2.toDataURL('image/png');
    const imgWidth2 = 210;
    const pageHeight2 = 297;
    const imgHeight2 = (canvas2.height * imgWidth2) / canvas2.width;
    pdf.addImage(imgData2, 'PNG', 0, 0, imgWidth2, imgHeight2);

    pdf.save("RD_Certificate.pdf");
  };

  // dynamic data........
  const { state } = useLocation();
  const currentRDRowData = state?.row;
  console.log("rd row data :", currentRDRowData)


  // Fetch Profile (runs once)
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);


  // Fetch Company and Nominee 
  useEffect(() => {
    const fetchAllData = async () => {
      if (!profile?.superAdminId) return; // Stop if profile not loaded yet

      // Fetch Company
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`
        );
        const companyData = await res.json();

        if (res.ok) {
          // Fix logo URL
          if (companyData.logo) {
            companyData.logoUrl = `https://payyug.in/${companyData.logo.replace(
              /^images\//,
              ""
            )}`;
          }

          setCompany(companyData);
        } else {
          console.error("Company fetch failed:", companyData);
        }
      } catch (err) {
        console.error("Company fetch error:", err);
      }

      // Fetch Nominee
      try {
        if (currentRDRowData?.customerId) {
          const nomineeRes = await fetch(
            `https://payyug.in/api/customer-nominee-filter?customerId=${currentRDRowData.customerId}&branchId=${currentRDRowData?.branchId}`
          );

          const nomiData = await nomineeRes.json();

          console.log("Nominee Data:", nomiData);

          if (nomiData?.data) {
            setNomineeData(nomiData.data);
          } else {
            setNomineeData([]); // in case of no nominee
          }
        }
      } catch (error) {
        console.log("Nominee fetch error:", error);
      }
    };

    fetchAllData();
  }, [profile?.superAdminId, currentRDRowData?.branchId, currentRDRowData?.customerId]);



  // static data
  const data = {
    receipt: "12324",
    nomineeName: "Mahendra Singh ",
  }



  return (
    <div className="RDcertificates-containers">
      <div id="page1">
        <div className="RDcertificates-container">
          <div className="RDcertificates-box">
            <div className="RDheaders">
              <div className="RDlefts">
                <div className="RDlogos">
                  <img src={company?.logoUrl} alt="Logo" />
                </div>
                <div className="rd-company-details">
                  <h1 className="RDtitles">{company?.name || "SANPANNATA MUTUAL BENEFIT NIDHI LIMITED."}</h1>
                  <p className="RDsubtitles">CIN No. : {company?.cin || "U64199MH2023PLN405930"}</p>
                  <p className="RDsubtitles">
                    Reg. Office: {company?.address || "Reg. Office & H.O.: Flat No. 2, Bldg. No. 2B, Ground Floor, Shree Gokul CHS,Vrindavan Society, Near Vrindavan Bus Stop, Thane (W) - 400601, Maharashtra"}
                  </p>
                </div>
                <div style={{ opacity: 0 }} className="RDlogos">
                  <img src={company?.logoUrl} alt="Logo" />
                </div>
              </div>
            </div>
            <div className="rd-header-container">
              <div className="rd-header-line"></div>

              <div className="rd-header-banner">
                <span className="rd-header-text-hindi">{currentRDRowData.accountType === "RD" ? "आवर्त जमा प्रमाणपत्र" : "डिमांड ड्राफ्ट प्रमाणपत्र"}</span>
                <span className="rd-header-separator">/</span>
                <span className="rd-header-text-english">{currentRDRowData.accountType === "RD" ? "Recurring Deposit Certificate" : "Demand Draft Certificate"}</span>
              </div>

              <div className="rd-header-line"></div>

              <div className="rd-header-office-copy">Original</div>
            </div>



            <div className="RDinfos-section">
              <div className="RDlefts-info">
                <div className="RDfields">
                  <label> A/C. No. &nbsp;&nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{currentRDRowData.accountNo || "N/A"}<br />(खाता सं.)</label>
                  {/* <input name="acNo" value={form.acNo}  /> */}
                </div>
                <div className="RDfields">
                  <label> Customer Id. &nbsp;&nbsp;&nbsp;:-  &nbsp;&nbsp;&nbsp;{currentRDRowData.customerId || "N/A"}<br />(ग्राहक आईडी)</label>
                  {/* <input name="receiptNo" value={form.receiptNo} /> */}
                </div>

                <div className="RDfields">
                  <label>Received From Shri/Smt. &nbsp;&nbsp;:-  &nbsp;&nbsp;&nbsp;{currentRDRowData.customerName || "N/A"} <br /> (श्री/श्रीमती से प्राप्त) </label>
                  {/* <input name="receivedFrom" value={form.receivedFrom}  /> */}

                </div>
                <div className="RDfields">
                  <label>Types of Deposit   &nbsp;:- &nbsp;&nbsp;&nbsp;{currentRDRowData.accountType === "DD" ? `(${currentRDRowData.accountType}) Account` : `${currentRDRowData.accountType} Account` || "N/A"}<br />(जमा के प्रकार)</label>
                  {/* <input
                name="typesOfDeposit"
                value={form.typesOfDeposit}
                
              /> */}
                </div>
                <div className="RDfields">
                  <label> Date &nbsp; :- &nbsp;&nbsp;&nbsp;{new Date(currentRDRowData.openingDate).toLocaleDateString("en-GB") || "N/A"} <br />(दिनांक)</label>
                  {/* <input name="date" value={form.date}  /> */}
                </div>
              </div>

              <div className="RDrights-info">

                <div className="RDfields">
                  <label>Nominee Name  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{nomineeData.nomineeName || "N/A"}<br />(नामांकित व्यक्ति का नाम)</label>
                  {/* <input name="nomineeName" value={form.nomineeName} /> */}
                </div>
                <div className="RDfields">
                  <label>Nominee Dob &nbsp; :- &nbsp;&nbsp;&nbsp;{nomineeData.nomineeDob || "N/A"}<br />(नामांकित व्यक्ति की जन्मतिथि)</label>
                  {/* <input name="age" value={form.age}  /> */}
                </div>
                <div className="RDfields">
                  <label>Nominee Relation &nbsp; :-&nbsp;&nbsp;&nbsp;{nomineeData.nomineeRelation || "N/A"}<br />(नामांकित व्यक्ति का संबंध)</label>
                  {/* <input name="relation" value={form.relation} /> */}
                </div>
                {/* <div className="RDfields">
              <label>A/C. No. &nbsp; :- &nbsp;&nbsp;&nbsp;{currentRDRowData.accountNo||"N/A"}<br />(खाता सं.)</label>
              <input name="acNo" value={form.acNo}  />
            </div> */}
              </div>
            </div>


            <div className="RDCdeposit-table">
              <table>
                <thead>
                  <tr>
                    <th>
                      {/* Per Month Rs. <br /> */}
                      <span className="RDCsub">Per Month Rs. <br /> प्रति माह रु.</span>
                    </th>
                    <th colSpan="2">

                      <span className="RDCsubs">Deposit Date / जमा तिथि</span>
                      <div className="RDCsub-header">
                        <div className="RDCsub">Start Date <br /> प्रारंभ तारीख</div>
                        <div className="RDCsub">Maturity Date <br /> परिपक्वता तिथि</div>
                      </div>
                    </th>
                    <th>
                      {/* Duration <br /> */}
                      <span className="RDCsub">Duration <br /> अवधि</span>
                    </th>
                    <th>
                      {/* Interest Rate <br /> */}
                      <span className="RDCsub">Interest Rate <br /> व्याज दर</span>
                    </th>
                    {/* Due Date <br /> */}
                    {/* <th>
              <span className="RDCsub">Due Date <br />नियत तारीख</span>
            </th> */}
                    <th>
                      {/* Maturity Amt. <br /> */}
                      <span className="RDCsub">Maturity Amt.<br /> परिपक्वता राशि</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{currentRDRowData.amount || ""}</td>
                    <td className="inner">{new Date(currentRDRowData.openingDate).toLocaleDateString("en-GB") || ""}</td>
                    <td className="inner">{new Date(currentRDRowData.maturityDate).toLocaleDateString("en-GB") || ""}</td>
                    <td>{currentRDRowData.tenure} ({currentRDRowData.installmentFrequency}) </td>
                    <td> {currentRDRowData.roi}  </td>
                    {/* <td></td> */}
                    <td>{currentRDRowData.maturityAmount}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="RDfooter">
              <div><br /> Cashier / कैशियर</div>
              <div><br /> Br. Manager / शाखाप्रमुख</div>
              <div><br /> Chairman / अध्यक्ष</div>
            </div>
          </div>   </div>


        <div className="divider"></div>
        {/* End of 1st Container */}

        {/* Start of 2nd  Container */}
        {/* <div className="RDcertificates-container">
      <div className="RDcertificates-box">
        <div className="RDheaders">
          <div className="RDlefts">
            <div className="RDlogos">
                <img src={company?.logoUrl} alt="Logo" />

            </div>
            <div>
              <h1 className="RDtitles">{company?.name||"SANPANNATA MUTUAL BENEFIT NIDHI LIMITED."}</h1>
              <p className="RDsubtitles">CIN No. : {company?.cin||"U64199MH2023PLN405930"}</p>
              <p className="RDsubtitles">
                Reg. Office: {company?.address||"Reg. Office & H.O.: Flat No. 2, Bldg. No. 2B, Ground Floor, Shree Gokul CHS,Vrindavan Society, Near Vrindavan Bus Stop, Thane (W) - 400601, Maharashtra"}
              </p>
            </div>
          </div></div>
       <div className="rd-header-container">
  <div className="rd-header-line"></div>

  <div className="rd-header-banner">
    <span className="rd-header-text-hindi">{currentRDRowData.accountType==="RD"?"आवर्त जमा प्रमाणपत्र":"डिमांड ड्राफ्ट प्रमाणपत्र"}</span>
    <span className="rd-header-separator">/</span>
    <span className="rd-header-text-english">{currentRDRowData.accountType==="RD"?"Recurring Deposit Certificate":"Demand Draft Certificate"}</span>
  </div>

  <div className="rd-header-line"></div>

  <div className="rd-header-office-copy">Duplicate</div>
</div>

        

        <div className="RDinfos-section">
          <div className="RDlefts-info">
            <div className="RDfields">
              <label> A/C. No. &nbsp;&nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{currentRDRowData.accountNo||"N/A"}<br />(खाता सं.)</label>
             
            </div>
            <div className="RDfields">
              <label> Customer Id. &nbsp;&nbsp;&nbsp;:-  &nbsp;&nbsp;&nbsp;{currentRDRowData.customerId||"N/A"}<br />(ग्राहक आईडी)</label>
             
            </div>
            
            <div className="RDfields">
              <label>Received From Shri/Smt. &nbsp;&nbsp;:-  &nbsp;&nbsp;&nbsp;{currentRDRowData.customerName||"N/A"} <br /> (श्री/श्रीमती से प्राप्त) </label>
             

            </div>
           
            <div className="RDfields">
              <label>Types of Deposit   &nbsp;:- &nbsp;&nbsp;&nbsp;{currentRDRowData.accountType==="DD"?`(${currentRDRowData.accountType}) Account`:`${currentRDRowData.accountType} Account`||"N/A"}<br />(जमा के प्रकार)</label>
            
            </div>
            <div className="RDfields">
              <label> Date &nbsp; :- &nbsp;&nbsp;&nbsp;{new Date(currentRDRowData.openingDate).toLocaleDateString("en-GB")||"N/A"} <br />(दिनांक)</label>
              
            </div>
          </div>

          <div className="RDrights-info">
            
             <div className="RDfields">
              <label>Nominee Name  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{nomineeData.nomineeName||"N/A"}<br />(नामांकित व्यक्ति का नाम)</label>
            
            </div>
            <div className="RDfields">
              <label>Nominee Dob &nbsp; :- &nbsp;&nbsp;&nbsp;{nomineeData.nomineeDob||"N/A"}<br />(नामांकित व्यक्ति की जन्मतिथि)</label>
              
            </div>
            <div className="RDfields">
              <label>Nominee Relation &nbsp; :-&nbsp;&nbsp;&nbsp;{nomineeData.nomineeRelation||"N/A"}<br />(नामांकित व्यक्ति का संबंध)</label>
            
            </div>
            
          </div>
        </div>

      
    <div className="RDCdeposit-table">
      <table>
        <thead>
          <tr>
            <th>
             
              <span className="RDCsub">Per Month Rs. <br /> प्रति माह रु.</span>
            </th>
            <th colSpan="2">
              
              <span className="RDCsubs">Deposit Date / जमा तिथि</span>
              <div className="RDCsub-header">
                <div className="RDCsub">Start Date <br /> प्रारंभ तारीख</div>
                <div className="RDCsub">Maturity Date <br /> परिपक्वता तिथि</div>
              </div>
            </th>
            <th>
            
              <span className="RDCsub">Duration <br /> अवधि</span>
            </th>
            <th>
              
              <span className="RDCsub">Interest Rate <br /> व्याज दर</span>
            </th>
             
            
            <th>
             
              <span className="RDCsub">Maturity Amt.<br /> परिपक्वता राशि</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{currentRDRowData.amount||""}</td>
            <td className="inner">{new Date(currentRDRowData.openingDate).toLocaleDateString("en-GB")||""}</td>
            <td className="inner">{new Date(currentRDRowData.maturityDate).toLocaleDateString("en-GB")||""}</td>
            <td>{currentRDRowData.tenure} ({currentRDRowData.installmentFrequency})</td>
            <td>{currentRDRowData.roi}</td>
          
            <td>{currentRDRowData.maturityAmount}</td>
          </tr>
        </tbody>
      </table>
    </div>
     <div className="RDfooter">
          <div><br /> Cashier / कैशियर</div>
          <div><br /> Br. Manager / शाखाप्रमुख</div>
          <div><br /> Chairman / अध्यक्ष</div>  
      </div>
       </div>  </div> */}

      </div>
      {/* End of 2nd Container */}

      {/* start of 1st Notice */}
      <div className="RDdivider"></div>
      <div id="page2">
        <div className="RDCnotice-container">
          {/* --- Heading --- */}
          <div className="RDCspecial-notice-header">
            <span className="RDCenglish-heading">Special Notice / </span>
            <span className="RDCmarathi-heading">विशेष सुचना</span>
          </div>

          {/* --- Rules/Points Section --- */}
          <div className="RDCrules-section">
            {/* Point 1 */}
            <div className="RDCrule-item">
              <span className="RDCrule-number">१)</span>
              <div className="RDCrule-text">
                <p className="RDCmarathi-text">
                  आवर्ती जमा में राशि निवेश करने के बाद जमा रसीद दी जाएगी और रसीद जमा करने के बाद, समाप्ति तिथि के बाद परिपक्वता राशि का भुगतान किया जाएगा।
                </p>
                <p className="RDCenglish-text">
                  Deposit receipt will be given after investing the amount in the recurring deposits and After submission of receipt, Maturity amount will be paid after the expiry date.
                </p>
              </div>
            </div>

            {/* Point 2 */}
            <div className="RDCrule-item">
              <span className="RDCrule-number">२)</span>
              <div className="RDCrule-text">
                <p className="RDCmarathi-text">
                  यदि रसीद खो जाए या क्षतिग्रस्त हो जाए तो स्टाम्प पेपर पर वैधता बनाना आवश्यक है।
                </p>
                <p className="RDCenglish-text">
                  If the receipt is lost or damaged, then it is necessary to make a validity on the stamp paper.
                </p>
              </div>
            </div>

            {/* Point 3 */}
            <div className="RDCrule-item">
              <span className="RDCrule-number">३)</span>
              <div className="RDCrule-text">
                <p className="RDCmarathi-text">
                  यदि खाता अवधि से पहले बंद हो जाता है, तो संगठन के नियमों के अनुसार ब्याज का भुगतान किया जाएगा।
                </p>
                <p className="RDCenglish-text">
                  In case the account will stop before period, interest will be paid as per organization's rules.
                </p>
              </div>
            </div>
          </div>

          {/* --- Table Section --- */}
          <div className="RDCsdeposit-table">
            <table>
              <thead>
                <tr>
                  <th>
                    {/* Per Month Rs. <br /> */}
                    <span className="RDCssub">Per Month Rs. <br /> प्रति माह रु.</span>
                  </th>
                  <th colSpan="2">

                    <span className="RDCssubs">Deposit Date / जमा तिथि</span>
                    <div className="RDCssub-header">
                      <div className="RDCssub">Start Date <br /> प्रारंभ तारीख</div>
                      <div className="RDCssub">Maturity Date <br /> परिपक्वता तिथि</div>
                    </div>
                  </th>
                  <th>
                    {/* Duration <br /> */}
                    <span className="RDCssub">Duration <br /> अवधि</span>
                  </th>
                  <th>
                    {/* Interest Rate <br /> */}
                    <span className="RDCssub">Interest Rate <br /> व्याज दर</span>
                  </th>
                  {/* Due Date <br /> */}
                  {/* <th>
              <span className="RDCssub">Due Date <br />नियत तारीख</span>
            </th> */}
                  <th>
                    {/* Maturity Amt. <br /> */}
                    <span className="RDCssub">Maturity Amt.<br /> परिपक्वता राशि</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{currentRDRowData.amount || ""}</td>
                  <td className="inner">{new Date(currentRDRowData.openingDate).toLocaleDateString("en-GB") || ""}</td>
                  <td className="inner">{new Date(currentRDRowData.maturityDate).toLocaleDateString("en-GB") || ""}</td>
                  <td>{currentRDRowData.tenure} ({currentRDRowData.installmentFrequency})</td>
                  <td>{currentRDRowData.roi}</td>
                  {/* <td></td> */}
                  <td>{currentRDRowData.maturityAmount}</td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* --- Footer/Signature Section --- */}
          <div className="RDCsignature-section">
            <div className="RDCreceipt-confirmation">
              <p className="RDCenglish-text">
                I received the amount along with the interest of the deposit as shown in the order.
              </p>
              <p className="RDCmarathi-text">
                मुझे आदेश में दर्शाई गई राशि के साथ-साथ जमा राशि पर ब्याज भी प्राप्त हुआ।
              </p>
            </div>
            <div className="RDCsignature-box-container">
              <div className="RDCsignature-box"></div>
              <div className="RDCsignature-labels">
                <p className="RDCenglish-text">**Signature of the account holder**</p>
                <p className="RDCmarathi-text">**खाताधारक के हस्ताक्षर**</p>
              </div>
            </div>
          </div>
        </div>

        {/* End  of 1st Notice */}
        <div className="RDdivider"></div>
        
      </div>
      <button className="RDCpdf-button" onClick={generatePDF}>Download PDF</button>
    </div>

  );
}